import "./styles/index.css";
import { Homepage } from "./pages";

function App() {
  return (
    <div className="App">
      <Homepage />
    </div>
  );
}

export default App;
